module.exports = __webpack_public_path__ + "static/media/sended-icon.8086889e.svg";